import React from 'react';
import './styles.scss';
import { Skeleton } from '@mantine/core';

const LoaderDataTables = () => {
  return (
    <table className="loader-datatables">
      <thead>
        <tr>
          {Array(3)
            .fill(0)
            .map((_, index) => (
              <th key={index}>
                <Skeleton width="100%" height={32} />
              </th>
            ))}
        </tr>
      </thead>

      <tbody>
        {Array(5)
          .fill(0)
          .map((_, index) => (
            <tr key={index}>
              {Array(3)
                .fill(0)
                .map((_, i) => (
                  <td key={i}>
                    <Skeleton width="100%" height={24} />
                  </td>
                ))}
            </tr>
          ))}
      </tbody>
    </table>
  );
};

export default LoaderDataTables;
